import React, {useState, useEffect} from "react";
import { useLocation } from 'react-router-dom';
import {Container, Row} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

import {Link} from "react-router-dom";
import StickyBox from "react-sticky-box";
import Cards from 'react-credit-cards-2';
import {FaGem} from "react-icons/fa"; // Importa o ícone de joia
import "react-credit-cards-2/dist/es/styles-compiled.css";
import "./assets/css/checkout.css";
import "bootstrap/dist/css/bootstrap.min.css";
import ApiService from "../util/ApiService";
import Swal from "sweetalert2";
import LoadingScreen from "../util/LoadingScreen";

const Checkout = (props) => {
    document.title = "Pagamento | Plantão Rápido";
    const [loadingPage, setLoadingPage] = useState(false);
    const [publicKey, setPublicKey] = useState("");
    const [sdkLoaded, setSdkLoaded] = useState(false);
    const [paymentSuccess, setPaymentSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");

    const location = useLocation();
    const plan = location.state?.plan;

    const [cardData, setCardData] = useState({
        number: "",
        name: "",
        expiryMonth: "",
        expiryYear: "",
        cvc: "",
        focus: "",
        brand: "",
    });

    useEffect(() => {
        const loadPublicKey = async () => {
            try {
                const response = await ApiService.send('post', process.env.REACT_APP_URL_API + 'payment/public-keys', {payment_platforms_id: 1}, true);

                const {data} = ApiService.handleApiResponse(response);


                if (data && data?.public_key) {
                    setPublicKey(data.public_key);
                } else {
                    console.error("Erro ao carregar a chave pública");
                }
            } catch (error) {
                ApiService.handleApiError(error);
            }
        };

        const loadPagSeguroSdk = () => {
            const script = document.createElement("script");
            script.src = "https://assets.pagseguro.com.br/checkout-sdk-js/rc/dist/browser/pagseguro.min.js";
            script.async = true;
            script.onload = () => setSdkLoaded(true);
            document.body.appendChild(script);
        };

        loadPublicKey();
        loadPagSeguroSdk();
    }, []);

    const handleInputChange = (e) => {
        setCardData({
            ...cardData,
            [e.target.name]: e.target.value,
        });
    };

    const handleInputFocus = (e) => {
        setCardData({
            ...cardData,
            focus: e.target.name,
        });
    };

    const formatExpiry = () => {
        const {expiryMonth, expiryYear} = cardData;
        return `${expiryMonth.padStart(2, "0")}/${expiryYear.slice(-2)}`;
    };

    const handlePurchase = () => {
        if (!sdkLoaded) {
            Swal.fire({
                icon: 'error',
                title: 'Erro!',
                text: "Erro ao carregar o SDK do PagSeguro. Por favor, recarregue a página.",
            });
            return;
        }

        const card = PagSeguro.encryptCard({
            publicKey,
            holder: cardData.name,
            number: cardData.number,
            expMonth: cardData.expiryMonth,
            expYear: cardData.expiryYear,
            securityCode: cardData.cvc,
        });

        if (card.hasErrors) {
            Swal.fire({
                icon: 'error',
                title: 'Erro!',
                text: "Erro ao criptografar os dados do cartão. Verifique as informações e tente novamente.",
            });
            return;
        }

        processPayment(card.encryptedCard);
    };

    const processPayment = (encryptedCard) => {
        const paymentData = {
            card_token: encryptedCard,
            card_holder_name: cardData.name,
            payment_plans_id: props.location?.state?.plan.id,
            payment_platforms_id: 1,
            registration_data: true,
            card_cvv: cardData.cvc,
        };

        setLoadingPage(true);
        ApiService.send("post", process.env.REACT_APP_URL_API + 'payment/register', paymentData, true)
            .then((res) => {
                if (res.code === 200) {
                    setPaymentSuccess(true);
                    setSuccessMessage("Pagamento realizado com sucesso. Obrigado por se tornar um membro do plano Pro!"); // Mensagem personalizada para o plano Pro
                }
            })
            .catch((error) => {
                const errorMessage = error.response?.data?.message || "Ocorreu um erro ao processar o pagamento.";
                const errorDetails = error.response?.data?.errors?.join(", ") || null;

                Swal.fire({
                    icon: 'error',
                    title: 'Erro!',
                    text: errorDetails ? `${errorMessage}: ${errorDetails}` : errorMessage,
                });
            })
            .finally(() => {
                setLoadingPage(false);
            });
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Pagamento" pageTitle="Financeiro"/>
                    <Row>
                        {loadingPage && <LoadingScreen/>}

                        <div className="col-md-7 col-lg-8">
                            <div className="card shadow-sm">
                                <div className="card-body">
                                    {paymentSuccess ? (
                                        // Exibe mensagem de sucesso após o pagamento
                                        <div className="text-center">
                                            <FaGem size={50} color="#ff6347" className="mb-3"/> {/* Ícone de joia */}
                                            <h3 className="mb-3">Sucesso!</h3>
                                            <p>{successMessage}</p>
                                            <p className="fw-bold">Aproveite todos os benefícios do
                                                plano  {plan?.name}!</p>
                                        </div>
                                    ) : (
                                        // Exibe o formulário do cartão antes do pagamento ser concluído
                                        <form>
                                            <div className="info-widget">
                                                <h5 className="mb-4">Informações de Pagamento</h5>
                                            </div>
                                            <div className="payment-widget">
                                                <div className="custom-card mb-4">
                                                    <Cards
                                                        number={cardData.number}
                                                        name={cardData.name}
                                                        expiry={formatExpiry()}
                                                        cvc={cardData.cvc}
                                                        focused={cardData.focus}
                                                        locale={{valid: "válido até"}}
                                                        placeholders={{name: "NOME DO TITULAR"}}
                                                        brand={cardData.brand}
                                                    />
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label htmlFor="card_name">Nome no Cartão</label>
                                                            <input
                                                                type="text"
                                                                name="name"
                                                                id="card_name"
                                                                className="form-control"
                                                                value={cardData.name}
                                                                onChange={handleInputChange}
                                                                onFocus={handleInputFocus}
                                                                autoComplete="off"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label htmlFor="card_number">Número do Cartão</label>
                                                            <input
                                                                type="text"
                                                                name="number"
                                                                id="card_number"
                                                                className="form-control"
                                                                value={cardData.number}
                                                                onChange={handleInputChange}
                                                                onFocus={handleInputFocus}
                                                                autoComplete="off"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="expiryMonth">Mês de Validade</label>
                                                            <input
                                                                type="text"
                                                                name="expiryMonth"
                                                                id="expiryMonth"
                                                                className="form-control"
                                                                placeholder=""
                                                                value={cardData.expiryMonth}
                                                                onChange={handleInputChange}
                                                                onFocus={handleInputFocus}
                                                                autoComplete="off"
                                                                maxLength="2"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="expiryYear">Ano de Validade</label>
                                                            <input
                                                                type="text"
                                                                name="expiryYear"
                                                                id="expiryYear"
                                                                className="form-control"
                                                                placeholder=""
                                                                value={cardData.expiryYear}
                                                                onChange={handleInputChange}
                                                                onFocus={handleInputFocus}
                                                                autoComplete="off"
                                                                maxLength="4"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="cvc">CVC</label>
                                                            <input
                                                                type="text"
                                                                name="cvc"
                                                                id="cvc"
                                                                className="form-control"
                                                                value={cardData.cvc}
                                                                onChange={handleInputChange}
                                                                onFocus={handleInputFocus}
                                                                autoComplete="off"
                                                                maxLength="3"
                                                            />
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="d-grid mt-4">
                                                    <button
                                                        type="button"
                                                        onClick={() =>handlePurchase()}
                                                        className={`btn btn-lg ${publicKey && sdkLoaded ? "btn-primary" : "btn-secondary disabled-button"}`}
                                                        disabled={!publicKey || !sdkLoaded} // Desativa o botão até que a chave pública e o SDK estejam carregados
                                                    >
                                                        Comprar Plano
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-5 col-lg-4 theiaStickySidebar">
                            <StickyBox offsetTop={20} offsetBottom={20}>
                                <div className="card booking-card shadow-sm">
                                    <div className="header-section" >
                                        <h6 className="card-title" style={{ marginLeft: 20, marginTop: 10  }}>Resumo do Plano</h6>
                                    </div>
                                    <div className="card-body">
                                        <div className="booking-doc-info">
                                            <div className="booking-info">
                                                <h5>{props.location?.state?.plan?.name}</h5>
                                                <p>
                                                    <strong>Investimento: </strong>
                                                    {new Intl.NumberFormat('pt-BR', {
                                                        style: 'currency',
                                                        currency: 'BRL'
                                                    }).format(plan?.value)} reais

                                                </p>
                                                <p>
                                                    <strong>Descrição: </strong>
                                                    {plan?.description}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </StickyBox>
                        </div>

                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Checkout;
